/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Text } from '../../../atoms/Text/Text';
import { DayBriefStopCard } from './components/DayBriefStopCard';
import { DAY_BRIEF_CARD_BASE_CLASS as baseClass } from './constants';
import './DayBriefRendererStyles.scss';
/**
 * DayBriefRenderer
 *
 * The technician's day as stop cards: a heading and summary, an optional notice,
 * one card per stop, then the closing line. Everything shown is server-composed
 * English (contract A8); this renders it and never recomputes it. A malformed
 * block throws here and is contained by AIAgentMessage's BlockErrorBoundary.
 *
 * @version 1.0.0
 * @since 2026-10-29
 */
export function DayBriefRenderer({ block }) {
    var _a;
    const brief = block;
    return (React.createElement("div", { className: baseClass },
        React.createElement("div", { className: `${baseClass}__intro` },
            React.createElement(Text, { variant: "medium", as: "h3", className: `${baseClass}__heading` }, brief.heading),
            React.createElement(Text, { variant: "body", as: "p", className: `${baseClass}__summary` }, brief.summary),
            brief.notice && (React.createElement(Text, { variant: "body", as: "p", className: `${baseClass}__notice` }, brief.notice))),
        brief.stops.map((stop, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(DayBriefStopCard, { key: `${index}-${stop.label}`, stop: stop }))),
        brief.closing_line && (React.createElement(Text, { variant: "body", as: "p", className: `${baseClass}__closing` }, brief.closing_line)), (_a = brief.footnotes) === null || _a === void 0 ? void 0 :
        _a.map((note, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(Text, { key: `${index}-${note}`, variant: "xx-small", as: "p", className: `${baseClass}__footnote` }, note)))));
}
